
































































import { Prop, Component, Vue, Watch, Mixins } from "vue-property-decorator";
import MonthPicker from "./private/MonthPicker.vue";
import AButton from "./private/AButton.vue";
import ID from "../../ID";

@Component({
    components: {
        MonthPicker,
        AButton,
    },
})
export default class AbcMonthPicker extends Vue {
    @Prop() value!: Date | null;
    @Prop({ default: null }) label!: string | null;
    @Prop({ default: null }) error!: string | boolean | null;
    @Prop() readonly rangeMin!: Date | null;
    @Prop() readonly rangeMax!: Date | null;
    @Prop() readonly availableDates!: Date[] | null;
    @Prop({ type: Boolean}) hideNotAvailableDates!: boolean;
    @Prop({ type: Boolean }) customWidth!: boolean;

    private id = ID.next();
    private refYear = new Date().getFullYear();

    @Watch("value", {immediate: true})
    onValueChange(){
        this.refYear = this.value?.getFullYear() || new Date().getFullYear();
    }

    private get isNavigationForwardButtonDisabled(){
        if(!this.rangeMax || !this.hideNotAvailableDates){
            return false;
        }
        const year = this.refYear + 1;
        return new Date(year, 0, 1) >= this.rangeMax;
    }

    private get isNavigationBackwardButtonDisabled(){
        if(!this.rangeMin || !this.hideNotAvailableDates){
            return false;
        }
        const year = this.refYear - 1;
        return new Date(year, 11, 31) <= this.rangeMin;
    }

    private get curMonth() {
        return this.value;
    }

    private set curMonth(val: Date | null) {
        this.$emit("input", val);
    }

    private setCurrentMonth() {
        const now = new Date();
        this.curMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    }
}
